
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
Datetime,
},
data() {
return {
dateStatus:false,
startDate:'',
endDate:'',
list:[],
order:0
}
},
created(){
this.setDate();
this.getList();
},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);

var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
showOperater(){
this.pickerStatus = true;
},
getList() {
this.$api.groupInvite({startDate:this.startDate,endDate:this.endDate,order:this.order}).then((res)=>{
if(res){
this.list = res.data;
}
})
},
sort(value){
this.order = value;
this.getList();
}
}
}



// WEBPACK FOOTER //
// ./src/pages/groupInvite.vue